/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

function addScript(src, scriptAsync) {
  const script = document.createElement("script")
  script.src = src
  script.async = scriptAsync
  document.body.appendChild(script)
}

export const onClientEntry = () => {
  addScript("/config.js", false)
}
